<template>
  <div class="panel panel-power-standard">
    <div class="panel-heading">
      <h3 class="panel-title" v-html="panelHeaderTextForStandard(standard)" />
    </div>
    <div class="panel-body">
      <StandardView
        :set-code="standard.standard_set_code"
        :long-ref="standard.standard_long_ref"
        :short-ref="standard.standard_short_ref"
        :standard-text="standard.standard_text"
        :core-purpose="standard.core_purpose"
        :info-obj="standard" />
    </div>
  </div>
</template>

<script>
import StandardView from '@/standards/StandardView.vue'
import { panelHeaderTextForStandard } from '@/components/goals/common/standard_panel_header_text.js'
export default {
  name: 'PowerStandard',
  components: {
    StandardView
  },
  props: {
    standard: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    panelHeaderTextForStandard(standard) {
      return panelHeaderTextForStandard(standard)
    }
  }
}
</script>

<style scoped lang="less">
.panel-power-standard {
  border: none;
  background-color: #d7dde6;

  .panel-heading {
    color: #fff;
    background-color: #1c5498;
    padding-top: 12px;
    padding-bottom: 12px;

    .label {
      position: relative;
      top: -1px;
    }

    .panel-title {
      font-size: 14px;
    }
  }

  /deep/ blockquote {
    padding: 2px 12px;
    padding-bottom: 4px;
    margin-bottom: 8px;
    border-color: #1c5498;
    font-size: 12px;
    p {
      font-style: italic;
      color: #454545;
    }
  }
}
</style>
